import script from "./zone-mgmt-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./zone-mgmt-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__